import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import settings from "../../config/settings";
import Checkout from "./Checkout";

const CheckoutPage = () => {
  const stripePromise = loadStripe(settings.stripe_public);

  return (
    <Elements stripe={stripePromise}>
      <Checkout />
    </Elements>
  );
};

export default CheckoutPage;
